
import EosAccounts from '@/api/eos-accounts'
import Wallet from '../../api/wallet'

export default {
  namespaced: true,
  state: {
    tokens: [],
    activeToken: 'HVT',
    tempTokenSymbol: null,
    linkedAccount: {
      account: null,
      permission: null
    },
    supportedTokens: [
      {
        'symbol': 'HVT',
        'name': 'Hirevibes',
        'account': 'hirevibeshvt'
      },
      {
        'symbol': 'EOS',
        'name': 'EOSIO',
        'account': 'eosio.token'
      }
    ],
    send: {
      to: null,
      quantity: null,
      memo: '',
      symbol: null,
      account: null
    },
    isStackConnected: false,
    stackUserData: null,
    stackUser: null,
    stackWalletStatus: null,
    error: null,
    loginToken: ''
  },
  getters: {
    getActiveToken: state => state.activeToken,
    getActiveTokenBalance (state) {
      return state.tokens.filter((token) => {
        return token.symbol === state.activeToken
      }).shift()
    },
    getSupportedTokenBySymbold (state) {
      return state.supportedTokens.filter((token) => {
        return token.symbol === state.tempTokenSymbol
      }).shift()
    }
  },
  mutations: {
    setSendTokenAccount (state, account) {
      state.send.account = account
    },
    setTokenReceiver (state, receiver) {
      state.send.to = receiver
    },
    setSendQuantity (state, quantity) {
      state.send.quantity = quantity
    },
    setSendSymbol (state, symbol) {
      state.send.symbol = symbol
    },
    setSendMemo (state, memo) {
      state.send.memo = memo
    },
    setTempTokenSymbol (state, symbol) {
      state.tempTokenSymbol = symbol
    },
    setToken (state, token) {
      const index = state.tokens.findIndex(t => t.symbol === token.symbol)
      if (index === -1) {
        state.tokens.push(token)
      } else {
        state.tokens[index] = token
      }
    },
    setTokens (state, tokens) {
      state.tokens = tokens
    },
    setActiveToken (state, token) {
      state.activeToken = token
    },
    setLinkedAccount (state, account) {
      state.linkedAccount = account
    },
    resetTransferAttributes (state) {
      state.send = {
        to: null,
        quantity: null,
        memo: '',
        symbol: state.send.symbol,
        account: state.send.account
      }
    },
    setStackUserData (state, userData) {
      state.stackUserData = userData
    },
    setIsStackConnected (state, isStackConnected) {
      state.isStackConnected = isStackConnected
    },
    setStackUser (state, stackUser) {
      state.stackUser = stackUser
    },
    setStackWalletStatus (state, stackWalletStatus) {
      state.stackWalletStatus = stackWalletStatus
    },
    setError (state, error) {
      state.error = error
    },
    setLoginToken (state, loginToken) {
      state.loginToken = loginToken
    }
  },
  actions: {
    async getLinkedEOSAccount ({commit}) {
      try {
        const r = await EosAccounts.current()
        commit('setLinkedAccount', {account: r.eosAccountName, permission: r.eosAccountPermission})
      } catch (err) {
        console.log(err)
      }
    },
    async fetchCurrencyBalance ({commit, state}, token) {

    },
    async fetchSupportedTokensBalance ({dispatch, state}) {
      state.supportedTokens.forEach(function (t) {
        dispatch('fetchCurrencyBalance', t)
      })
    },
    connectStack ({commit}, {userData, user}) {
      commit('setStackUserData', userData)
      commit('setIsStackConnected', true)
      commit('setStackUser', user)
    },
    disconnectStack ({commit}) {
      commit('setStackUserData', null)
      commit('setIsStackConnected', false)
      commit('setStackUser', null)
    },
    async getStackWalletStatus ({commit}) {
      const stackWalletStatus = await Wallet.getWalletStatus()
      commit('setStackWalletStatus', stackWalletStatus)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/wallet.js